export class MathUtil {
    static lerp(left, right, amount) {
        return left * (1 - amount) + right * amount;
    }
    static repeat(t, length) {
        return t - Math.floor(t / length) * length;
    }
    static distance(x1, y1, x2, y2) {
        return Math.sqrt(Math.pow(x1 - x2, 2) + Math.pow(y1 - y2, 2));
    }
    static clamp(value, min, max) {
        if (value < min)
            value = min;
        else if (value > max)
            value = max;
        return value;
    }
    static clamp01(value) {
        if (isNaN(value))
            value = 0;
        else if (value > 1)
            value = 1;
        else if (value < 0)
            value = 0;
        return value;
    }
    static slerpQuaternionArray(a, Offset1, b, Offset2, t, out, Offset3) {
        var ax = a[Offset1 + 0], ay = a[Offset1 + 1], az = a[Offset1 + 2], aw = a[Offset1 + 3], bx = b[Offset2 + 0], by = b[Offset2 + 1], bz = b[Offset2 + 2], bw = b[Offset2 + 3];
        var omega, cosom, sinom, scale0, scale1;
        cosom = ax * bx + ay * by + az * bz + aw * bw;
        if (cosom < 0.0) {
            cosom = -cosom;
            bx = -bx;
            by = -by;
            bz = -bz;
            bw = -bw;
        }
        if ((1.0 - cosom) > 0.000001) {
            omega = Math.acos(cosom);
            sinom = Math.sin(omega);
            scale0 = Math.sin((1.0 - t) * omega) / sinom;
            scale1 = Math.sin(t * omega) / sinom;
        }
        else {
            scale0 = 1.0 - t;
            scale1 = t;
        }
        out[Offset3 + 0] = scale0 * ax + scale1 * bx;
        out[Offset3 + 1] = scale0 * ay + scale1 * by;
        out[Offset3 + 2] = scale0 * az + scale1 * bz;
        out[Offset3 + 3] = scale0 * aw + scale1 * bw;
        return out;
    }
    static getRotation(x0, y0, x1, y1) {
        return Math.atan2(y1 - y0, x1 - x0) / Math.PI * 180;
    }
    static sortBigFirst(a, b) {
        if (a == b)
            return 0;
        return b > a ? 1 : -1;
    }
    static sortSmallFirst(a, b) {
        if (a == b)
            return 0;
        return b > a ? -1 : 1;
    }
    static sortNumBigFirst(a, b) {
        return parseFloat(b) - parseFloat(a);
    }
    static sortNumSmallFirst(a, b) {
        return parseFloat(a) - parseFloat(b);
    }
    static sortByKey(key, bigFirst = false, forceNum = true) {
        var _sortFun;
        if (bigFirst) {
            _sortFun = forceNum ? MathUtil.sortNumBigFirst : MathUtil.sortBigFirst;
        }
        else {
            _sortFun = forceNum ? MathUtil.sortNumSmallFirst : MathUtil.sortSmallFirst;
        }
        return function (a, b) {
            return _sortFun(a[key], b[key]);
        };
    }
    static roundTo(value, decimals = 3, epsilon = 1e-6) {
        if (!isFinite(value))
            return value;
        const factor = Math.pow(10, decimals);
        const rounded = Math.round(value * factor) / factor;
        return Math.abs(rounded) < epsilon ? 0 : rounded;
    }
}
